import { render } from "./CAlert.vue?vue&type=template&id=8e707bdc&scoped=true"
import script from "./CAlert.vue?vue&type=script&lang=js"
export * from "./CAlert.vue?vue&type=script&lang=js"

import "./CAlert.vue?vue&type=style&index=0&id=8e707bdc&lang=scss&scoped=true"

import exportComponent from "/Applications/dev/FLEXX_FREIGHT/flexx-freight-stats/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e707bdc"]])

export default __exports__